import type { ActiveDailyItem } from "../types/domain";

export function pickActiveItemIndex(items: ActiveDailyItem[], currentStep: number): number {
  if (!items.length) return 0

  // First actionable
  const actionableIdx = items.findIndex(i => i.status === 'unused' || i.status === 'auto')
  if (actionableIdx !== -1) return actionableIdx

  // Next upcoming reward at/after currentStep
  const nextIdx = items.findIndex(i => i.step >= currentStep)
  if (nextIdx !== -1) return nextIdx

  // Most recent past reward
  for (let i = items.length - 1; i >= 0; i--) {
    const item = items[i]
    if (item && item.step < currentStep) return i
  }

  // Fallback
  return 0
}
